const STORIES = [
  { name: "Sam, 42", track: "GYM", body: "Sleep back to 7h+. Waist down 4cm. First deadlift PB in 12 years." },
  { name: "Rita, 51", track: "HOME", body: "Walked 10K a day for 8 weeks straight. Blood pressure down. Confidence up." },
  { name: "Dan, 34", track: "GYM", body: "Weekend chaos traded for Monday clarity. Down 6kg, up energy. Still built." },
  { name: "Priya, 46", track: "HOME", body: "Post-kids rebuild. Squats without knees complaining. First 5k jog." },
  { name: "Marc, 57", track: "START", body: "Started with walks. Twelve weeks later, three lifts a week." },
  { name: "Anna, 38", track: "GYM", body: "The plate rules changed everything. No counting. Just full plates." },
];

export default function Results() {
  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
      <div className="label-eyebrow">Member Wins</div>
      <h1 className="wordmark mt-4 text-5xl md:text-7xl uppercase leading-[0.9]">Real Adults.<br /><span className="text-primary">Real Rebuilds.</span></h1>
      <p className="mt-8 max-w-2xl text-lg text-foreground/80">Personal bests — not leaderboards. No ranking. No comparing.</p>
      <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {STORIES.map((s) => (
          <div key={s.name} className="bg-card border border-border rounded-lg p-7">
            <div className="label-eyebrow">Track · {s.track}</div>
            <p className="mt-3 font-head text-xl leading-snug">&ldquo;{s.body}&rdquo;</p>
            <div className="mt-4 text-sm text-foreground/60">— {s.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
